import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/reprogramar', name: 'Reprogramar', component: () => import('../views/Reprogramar.vue') },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
	{
		path: '/nuevo',
		name: 'Nuevo',
		component: () => import('@/views/Nuevo.vue')
	},
	{
		path: '/asignar',
		name:'Asignar',
		component: () => import('@/views/Asignar.vue')
	},
  {
    path: '/usuarios',
    name: 'Usuarios',
    component: () => import('@/views/Usuarios.vue')
  },
	{
		path: '/llamadas',
		name: 'Llamadas',
		component: () => import('@/views/Llamadas.vue')
	},
	{
		path: '/enEspera',
		name: 'EnEspera',
		component: () => import('@/views/EnEspera.vue')
	},
	{
		path: '/busqueda',
		name: 'Búsqueda',
		component: () => import('@/views/Busqueda.vue')
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
